import React from "react";
import { motion, Variants } from "framer-motion";
import { MessageSquare, Monitor, X, Info } from "lucide-react";

interface InsightCardsProps {
    onClose: () => void;
    type?: string;
}

export const InsightCards = ({ onClose }: InsightCardsProps) => {

    const slideshowCardStyles = "text-orange-500 border-orange-200 bg-orange-500/5";
    const slackCardStyles = "text-blue-500 border-blue-200 bg-blue-500/5";
    
    const cardVariants: Variants = {
        hidden: {
            opacity: 0,
            x: 50,
            scale: 0.9
        },
        visible: (delaySec: number) => ({
            opacity: 1,
            x: 0,
            scale: 1,
            transition: {
                delay: delaySec,
                type: "spring",
                stiffness: 300,
                damping: 25
            },
        }),
        exit: {
            opacity: 0,
            x: 20,
            scale: 0.95,
            transition: { duration: 0.2 }
        },
    };

    return (
        <div className="fixed bottom-4 right-4 z-40 flex flex-col gap-3 w-full max-w-sm pointer-events-auto">

            {/* Slideshow Card */}
            <motion.div
                custom={3}
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={cardVariants}
                className={`relative p-4 rounded-lg border flex items-start gap-3 shadow-sm ${slideshowCardStyles}`}
            >
                <button onClick={onClose} className="absolute top-2 right-2 opacity-50 hover:opacity-100">
                    <X className="size-4" />
                </button>

                <div className="mt-0.5">
                    <Monitor className="size-6" />
                </div>
                <div>
                    <h4 className="font-bold text-sm flex items-center gap-2">
                        <Info className="size-3" /> Heads up
                    </h4>
                    <p className="text-xs mt-1 text-gray-500">
                        Check the <span className="font-medium text-orange-600">slideshow page</span> to see it displayed.
                    </p>
                </div>
            </motion.div>

            {/* Slack Channel Card */}
            <motion.div
                custom={5}
                initial="hidden"
                animate="visible"
                exit="exit"
                variants={cardVariants}
                className={`relative p-4 rounded-lg border flex items-start gap-3 shadow-sm ${slackCardStyles}`}
            >
                <button onClick={onClose} className="absolute top-2 right-2 opacity-50 hover:opacity-100">
                    <X className="size-4" />
                </button>

                <div className="mt-0.5">
                    <MessageSquare className="size-6" />
                </div>
                <div>
                    <h4 className="font-bold text-sm flex items-center gap-2">
                        <Info className="size-3" /> Quick note
                    </h4>
                    <p className="text-xs mt-1 text-gray-500">
                        Your recognition will appear in the <span className="font-medium text-blue-600">#team-announcements Slack channel</span>.
                    </p>
                </div>
            </motion.div>
        </div>
    );
};